import 'styles/pages/community';

import VideoTestimonials from 'common/video_testimonials';

if (document.querySelector('.js-community-page')) {
  new VideoTestimonials();
}



// WEBPACK FOOTER //
// ./app/javascript/pages/community.js